import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Container,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { InputYear } from "../Components/Inputs/Input_Year.jsx";
import { set } from "lodash";

import ValueInflatable from "./ValueInflatable.jsx";
import {
  CollapseDelete,
  Up,
  Down,
  CollapseAddLabel,
} from "./CollapseButtons.jsx";
import { AddDialog } from "../Components/AddDialog.jsx";
import {
  getOptions,
  putOptions,
  AddIncomeUrl_get,
  AddIncomeUrl_put,
  ftchPlus,
  CleanAvail,
} from "./Account_urls.jsx";
import { InputPercentage } from "../Components/Inputs/Input_Percentage.jsx";
import { errorCheckForm, errorClear, errorJsonHasErrors, errorSet, errorSetPlus } from "../Components/Inputs/Input_Fns.jsx";
import { InputSelect1, InputSelectN } from "../Components/Inputs/Select.jsx";
import { InputAccountTypeName } from "../Components/Inputs/Account_TypeName.jsx";
import { InputCheck } from "../Components/Inputs/Input_Check.jsx";
import { Arrayify } from "../Functions/utils.jsx";
import { CombinedAccountNameList, PenSlash } from "./AddSavingRule.jsx";
import { AddIncomeRuleText } from "../Functions/addIncomeRuleText.jsx";

var inf_value = {
  Value: 0,
  Year: new Date().getFullYear() - 1,
  Threshold: 0,
  Type: "Yearly",
  Rate: 0,
};

var fromA = {
  Id: 0,
  AccountType: "",
  AccountName: "",
  Who: ["Personal"],
};

var to = {
  Uuid: 0,
  Account: fromA,
  Method: "",
  Value: inf_value,
  Percent: 0,
  Min: inf_value,
  Max: inf_value,
  FromMin: inf_value,
  OnlyRequired: true,
  IncludesMinimum: false,
  TextRule: "Empty",
  Changed: true,
};


const ToAccount = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  doValidation,
  onError,
}) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = structuredClone(form);
    nf[n] = v;
    nf.Changed = true;
    console.log(nf);
    onChange(nf);
    return nf
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };
  const onChange_select = (e) => {
    let nf = onChange_any(e.target.name, e.target.value);
    // here we validate on the nf since form isn't updated yet
    validate(nf)
  }

  const onChangeValue = (value, uptoage, SpousePercentage, name) => {
    let nf = {
      ...form,
      [name]: value,
      "Changed": true,
    };
    onChange(nf);
  };

  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }

  const validate = (f) => {
    let ne = structuredClone(errors)

    let err = (f.Method === "") ? "Please set a method" : ""
    ne = set(ne, "Method", err)

    err = (f.Method === "PercentOfEmployment" && f.EmploymentAccount === "") ? "Please enter an Account" : ""
    ne = set(ne, "EmploymentAccount", err)

    console.log(ne)
    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  useEffect(() => {
    // here we validate on the form
    validate(form)
  }, [doValidation])

  return (
    <Container maxWidth="true">
      {/* <Container> */}
      <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
        <Stack direction="row" spacing={2}>
          <Stack spacing={2}>
            <FromAccount
              avail={avail}
              availSpouse={availSpouse}
              form={form.Account}
              direction="row"
              label="From"
              onChange={(e) => onChange_any("Account", e)}
              accountType={accountType}
              accountTypeSpecific={form.Type}
              onError={(e) => myError("From", 0, e)}
              doValidation={doValidation}
            />
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <InputSelect1
              label="Method"
              name="Method"
              value={form.Method}
              onChange={onChange_select}
              errors={errors}
              avail={avail.Methods}
              minWidth={240}
            />

            <ValueInflatable
              form={form.Value}
              label=""
              onChange={onChangeValue}
              avail={avail}
              name="Value"
              color="delete"
              showInf={false}
              disabled={
                !(
                  form.Method.includes("Value") ||
                  form.Method.includes("Minimum")
                )
              }
              onError={(e) => myError("valueI", null, e)}

            />
            <Stack direction="row" spacing={2}>
              <InputPercentage
                label="Percent"
                name="Percent"
                disabled={!form.Method.includes("Percent")}
                percent={form.Percent}
                onChange={onChange_t}
                onError={(e) => myError("percent", null, e)}

              />

            </Stack>
          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <Stack >
              <Typography sx={{ mt: -2 }} id="s-die-age-slider" variant="h6" gutterBottom={false}>
                Limits
              </Typography>
              <InputCheck
                label="Only Required"
                name="OnlyRequired"
                value={form.OnlyRequired}
                onChange={onChange_any}
                disabled={
                  !(
                    form.Method.includes("Flat") ||
                    form.Method.includes("Available")
                  )}
                sx={{ mt: -3, ml: -2, mb: -2 }}
              />
              <InputCheck
                label="Includes Minimums"
                name="IncludesMinimum"
                value={form.IncludesMinimum}
                onChange={onChange_any}
                disabled={
                  !(
                    form.Method.includes("Flat") ||
                    form.Method.includes("Available")
                  )}
                sx={{ mt: -3, ml: -2, mb: -2 }}
              />
            </Stack>
            <ValueInflatable
              form={form.Min}
              label="Min"
              onChange={onChangeValue}
              avail={avail}
              name="Min"
              color="delete"
              showInf={false}
              onError={(e) => myError("min", null, e)}

            />
            <ValueInflatable
              form={form.Max}
              label="Max"
              onChange={onChangeValue}
              avail={avail}
              name="Max"
              color="delete"
              showInf={false}
              onError={(e) => myError("max", null, e)}

            />

          </Stack>
          <Divider orientation="vertical" flexItem />

          <Stack spacing={2}>
            <Stack>
              <Typography sx={{ mt: -2 }} id="s-die-age-slider" variant="h6" gutterBottom>
                Constraints
              </Typography>
            </Stack>
            <ValueInflatable
              form={form.FromMin}
              label="From Min"
              onChange={onChangeValue}
              avail={avail}
              name="FromMin"
              color="delete"
              showInf={false}
              valueMin={-100000000}
              onError={(e) => myError("frommin", null, e)}

            />
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
};

const ToAccountAccordion = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  doValidation,
  onError,
}) => {
  const [error, setError] = useState(false)

  const myError = (e) => {
    setError(errorJsonHasErrors(e))
    onError(e)
  }

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
        <PenSlash
          changed={form.Changed}
          error={error}
        />
        <Stack spacing={2}>
          <Typography        >
            {form.TextRule}
            <br />
          </Typography>
          <Typography color="#228B22">
            {form.NewTextRule}
          </Typography>
        </Stack>

      </AccordionSummary>
      <AccordionDetails>
        <ToAccount
          avail={avail}
          availSpouse={availSpouse}
          form={form}
          onChange={onChange}
          accountType={accountType}
          accountTypeSpecific={accountTypeSpecific}
          doValidation={doValidation}
          onError={myError}
        />
      </AccordionDetails>
    </Accordion>

  )
}

const FromAccount = ({
  avail,
  availSpouse,
  form,
  onChange,
  accountType,
  accountTypeSpecific,
  direction,
  label,
  doValidation,
  onError
}) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {
    console.log("VY:change");
    console.log(form);
    console.log(n);
    console.log(v);
    let nf = structuredClone(form);
    nf[n] = v;
    console.log(nf);
    onChange(nf);
    return nf
  };



  const onChange_list = (e) => {
    const value = e.target.value;
    const values = typeof value === "string" ? value.split(",") : value;
    console.log(values);
    let nf = onChange_any(e.target.name, values);
    validate(nf)
  };

  const nt_Change = (name, type) => {

    console.log(name);
    console.log(type);

    let nf = structuredClone(form);
    nf["AccountName"] = name;
    nf["AccountType"] = type;
    console.log(nf);
    onChange(nf);

  };

  const validate = (f) => {
    let ne = structuredClone(errors)
    let err = (f.Who.length === 0) ? "Please select Who" : ""
    ne = set(ne, "Who", err)

    setErrors(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }

  }


  useEffect(() => {
    validate(form)
  }, [doValidation])


  const AccountList = () => {
    return CombinedAccountNameList(form.Who, avail, availSpouse, label)
  }


  return (
    <Container maxWidth="true">
      {/* <Container> */}

      <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
        <Typography id="s-die-age-slider" variant="h6" gutterBottom>
          {label + " Account"}
        </Typography>
        <Stack direction={direction} spacing={2}>
          <InputSelectN
            label="Who"
            name="Who"
            value={form.Who}
            onChange={onChange_list}
            errors={errors}
            avail={avail.Who}
            minWidth={180}
          />

          <InputAccountTypeName
            avail={AccountList()}
            inputForm={form}
            onChange={nt_Change}

            onError={(e) => errorSetPlus(onError, errors, setErrors, "accounts", 0, e)}
          />
        </Stack>
      </Box>
    </Container>
  );
};

const AddIncomeRule = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  accountType,
  add,
  when,
  year,
  spouseFirst = false,
  copy = false,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [spouse, setSpouse] = useState("");
  const [added, setAdded] = useState([false, false]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [doValidation, setDoValidation] = useState(0)
  const [deleted, setDeleted] = useState(false)
  const [availSpouse, setAvailSpouse] = useState({})

  const getInputData = (client_, extraArg) => {
    let url = AddIncomeUrl_get(clientJson, "additionalincome", year, add, extraArg);

    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setAdded([false, false]);
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  const putRequest = async (extraArg) => {
    let url = AddIncomeUrl_put(clientJson, "additionalincome", year, extraArg);

    let post = CleanAvail(form);
    var req = putOptions;
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((response) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {

      console.log("on submit");
      console.log(form);
      putRequest("");
    }
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      let extraArg = ""
      if (spouseFirst) {
        extraArg = "spouse=true"
      }
      if (copy) {
        if (extraArg !== "") {
          extraArg += "&"
        }
        extraArg += "copy=true"
      }
      getInputData(client_p, extraArg);
    }
  }, [show]);

  useEffect(() => {
    let cl = client === clients[0] ? 0 : 1;
    if (add && dataset && !added[cl]) {
      if (dataset.From && dataset.From.length === 0) {
        onAddFrom();
      }
      let x = added;
      x[cl] = true;
      setAdded(x);
    }
  }, [add, dataset]);
  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);

    setSpouse("")
    setAvailSpouse({})
    for (let c of data.current.Clients) {
      if (c !== cl) {
        setSpouse(c)
        setAvailSpouse(data.current.DataSet[c].Avail)
      }
    }
  };

  const anyChange = (subpath, any) => {
    console.log("any_change: ");
    console.log(any);
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    console.log("Path: " + path);
    let nf = form;
    nf = set(nf, path, any);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    console.log(nf);
  };

  const onChangeSub = (e, name, i) => {
    console.log("SA: " + name);
    console.log(e);
    console.log(i);

    let path = name + "[" + i + "]";
    e.NewTextRule = AddIncomeRuleText(e, dataset.Avail.RegisteredAccountNames, dataset.Avail.MaxLimitAccountNames)

    anyChange(path, e);

    // let json = data.current.DataSet[client][name].slice();
    // json = json.filter((o) => o.length !== 0);
    // console.log(json);
    // anyChange(name, json);
  };

  const btnClientChanged = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    anyChange(e.target.name, e.target.value);
  };



  const onAddFrom = (e) => {
    let n = structuredClone(to);
    let json = [];
    if (dataset.From) {
      json = dataset.From.slice();
      n.Id = Math.max(...dataset.From.map((o) => o.Id), 0) + 1;
    }
    json.push(n);
    console.log(json);
    anyChange("From", json);
  };
  const onDeleteFrom = (e, Id) => {
    let json = dataset.From.slice();
    json = json.filter((o) => o.Id !== Id);
    errorClear(errors)
    anyChange("From", json);
    setDeleted(true)
  };

  const FromIncrease = (e, i) => {
    let json = dataset.From.slice();
    let t = json[i]
    json[i] = json[i - 1]
    json[i - 1] = t
    anyChange("From", json);
  }
  const FromDecrease = (e, i) => {
    let json = dataset.From.slice();
    let t = json[i]
    json[i] = json[i + 1]
    json[i + 1] = t
    anyChange("From", json);
  }


  const myError = (obj, i, err) => {
    errorSet(errors, setErrors, obj, i, err)
  }

  const copyAllRulesToSpouse = () => {
    errorCheckForm()
    console.log(errors)
    if (!errorJsonHasErrors(errors)) {
      console.log("on submit");
      console.log(form);
      putRequest("copyToSpouse=" + spouse);
    }


  }

  const spouseButtonCheck = () => {
    if (!(data !== null && dataset !== undefined && dataset !== null)) {
      return false
    }
    if (spouse === "") {
      return false
    }
    if (dataset.FromSpouse) {
      return false
    }

    if (dataset.SpouseUseSameRules) {
      return false
    }
    return true
  }


  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={"Additional " + accountType + " Rules"}
        accountType={accountType}
        onClientChange={btnClientChanged}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}
        extraButton={spouseButtonCheck() ? "Submit <<" + client + "'s>> rules and Copy rules to <<" + spouse + ">>" : null}
        extraButtonTooltip={"Submit this rule, and then while doing copy all rules to spouse, replacing all " + spouse + "'s rules"}
        onExtraButton={copyAllRulesToSpouse}

      >
        {data !== null && dataset !== undefined && dataset !== null && (

          <Stack sx={{ mx: 4 }} spacing={2} >
            {spouse !== "" && (
              <Stack>
                <Box sx={{ mt: 1, mb: 2, p: 1, border: "1px solid grey" }}>
                  <Stack sx={{}} direction="row" spacing={2}>
                    <InputCheck
                      value={dataset.FromSpouse}
                      label={"Use Rules From " + spouse}
                      disabled={true}
                    />
                    {!dataset.FromSpouse && (
                      <InputCheck
                        value={dataset.SpouseUseSameRules}
                        label={spouse + " uses all these Rules"}
                        name="SpouseUseSameRules"
                        onChange={(name, value) => anyChange(name, value)}
                      />
                    )}
                  </Stack>
                </Box>
              </Stack>
            )}
            {!dataset.FromSpouse && (
              <>
                {dataset !== undefined && (
                  <Stack sx={{ pt: 4 }} direction="row" spacing={2}>
                    <InputYear
                      year={dataset.Year}
                      birthYear={dataset.BirthYear}
                      onChange={onChange_t}
                      onError={(e) => { setDoValidation(doValidation + 1); myError("year", 0, e) }}
                    />
                  </Stack>
                )}

                <Stack direction="row" spacing={2}>
                  <Stack sx={{ py: 4 }}>
                    <CollapseAddLabel
                      label="Rule"
                      onClick={onAddFrom}
                      tooltip="Add a new To Account"
                    />
                  </Stack>
                  <Stack spacing={2}>
                    {Arrayify(dataset.From).map((d, i) => (
                      <Stack key={"ft-" + d.Id} direction="row" spacing={2}>
                        <ToAccountAccordion
                          avail={dataset.Avail}
                          availSpouse={availSpouse}
                          form={d}
                          direction="row"
                          label="From"
                          onChange={(e) => onChangeSub(e, "From", i)}
                          accountType={accountType}
                          accountTypeSpecific={dataset.Type}
                          doValidation={doValidation}
                          onError={(e) => myError("toaccount", i, e)}

                        />
                        <Stack direction="row" spacing={2} sx={{ py: 4 }} >
                          <Stack direction="row" spacing={2} sx={{ pr: 2 + (i === dataset.From.length - 1 ? 7 : 0), pl: (i === 0 ? 7 : 0) }} >
                            {(i !== 0) && (
                              <Up onClick={(e) => FromIncrease(e, i)} />
                            )}
                            {(i !== dataset.From.length - 1) && (
                              <Down onClick={(e) => FromDecrease(e, i)} />
                            )}
                          </Stack>
                          <CollapseDelete
                            onClick={(e) => onDeleteFrom(e, d.Id)}
                          />
                        </Stack>
                      </Stack>
                    ))}
                  </Stack>

                </Stack>
              </>
            )}
          </Stack>
        )}

      </AddDialog >
    </>
  );
};

export default AddIncomeRule;
